"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VideoButton = _interopRequireDefault(require("../VideoButton/VideoButton"));
var _videoText = _interopRequireDefault(require("../../../videoText"));
var _utils = require("../../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const VolumeSliderContainer = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "VolumeSlider__VolumeSliderContainer",
  componentId: "components-web__sc-apixz4-0"
})(_ref => {
  let {
    videoPlayerWidth,
    compactModeThreshold,
    margin
  } = _ref;
  return {
    display: 'flex',
    width: videoPlayerWidth > compactModeThreshold ? '12%' : '20%',
    maxWidth: 120,
    margin,
    alignItems: 'center'
  };
});
const sharedStyles = _ref2 => {
  let {
    thumbHeight,
    thumbWidth,
    thumbBackground,
    trackGradientStart,
    trackGradientEnd
  } = _ref2;
  return {
    thumb: {
      appearance: 'none',
      height: thumbHeight,
      width: thumbWidth,
      borderRadius: '50%',
      background: thumbBackground,
      cursor: 'pointer',
      marginTop: -3,
      '&:hover': {
        transform: 'scale(1.5)'
      }
    },
    track: videoCurrentVolume => ({
      width: '100%',
      height: 2,
      cursor: 'pointer',
      borderRadius: 1.3,
      background: `linear-gradient(to right, ${trackGradientStart} 0%, ${trackGradientEnd} ${videoCurrentVolume * 100 - 0.01}%, rgba(255,255,255,0.5) ${videoCurrentVolume * 100}%)`
    })
  };
};
const StyledVolumeSlider = /*#__PURE__*/_styledComponents.default.input.attrs(_ref3 => {
  let {
    videoCurrentVolume
  } = _ref3;
  return {
    value: videoCurrentVolume
  };
}).withConfig({
  displayName: "VolumeSlider__StyledVolumeSlider",
  componentId: "components-web__sc-apixz4-1"
})(_ref4 => {
  let {
    videoCurrentVolume,
    rangeBackground,
    ...sharedProps
  } = _ref4;
  return {
    width: '100%',
    cursor: 'pointer',
    padding: '5px 0',
    'input[type=range]&': {
      appearance: 'none',
      width: '100%',
      background: rangeBackground
    },
    'input[type=range]&:focus': {
      outline: 'none'
    },
    'input[type=range]&::-webkit-slider-thumb': sharedStyles(sharedProps).thumb,
    'input[type=range]&::-moz-range-thumb': {
      ...sharedStyles.thumb,
      border: 'none'
    },
    'input[type=range]&::-ms-thumb': {
      ...sharedStyles.thumb,
      margin: 0,
      border: 'none'
    },
    'input[type=range]&::-webkit-slider-runnable-track': sharedStyles(sharedProps).track(videoCurrentVolume),
    'input[type=range]&::-moz-range-track': sharedStyles(sharedProps).track(videoCurrentVolume),
    'input[type=range]&::-ms-track': {
      ...sharedStyles(sharedProps).track(videoCurrentVolume),
      margin: '6px 0',
      border: 'none'
    },
    'input[type=range]&::-ms-fill-lower': {
      background: 'transparent'
    },
    'input[type=range]&::-ms-tooltip': {
      display: 'none'
    }
  };
});
const VolumeSlider = _ref5 => {
  let {
    setVolume,
    compactModeThreshold,
    disableFocus,
    videoPlayerWidth,
    videoIsMuted,
    videoCurrentVolume,
    copy,
    toggleMute,
    resetInactivityTimer,
    tokens,
    variant,
    ...rest
  } = _ref5;
  const refVolumeSlider = _react.default.useRef();
  const {
    marginLeft,
    marginRight,
    thumbHeight,
    thumbWidth,
    thumbBackground,
    trackGradientStart,
    trackGradientEnd,
    rangeBackground,
    mutedIcon,
    unmutedIcon
  } = (0, _componentsBase.useThemeTokens)('VideoVolumeSlider', tokens, variant);
  const sharedProps = {
    thumbHeight,
    thumbWidth,
    thumbBackground,
    trackGradientStart,
    trackGradientEnd,
    rangeBackground
  };
  const handleVolumeChange = () => setVolume(refVolumeSlider.current.value);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(VolumeSliderContainer, {
    compactModeThreshold: compactModeThreshold,
    videoPlayerWidth: videoPlayerWidth,
    margin: `0 ${marginRight}px 0 ${marginLeft}px`,
    ...selectProps(rest),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_VideoButton.default, {
      icon: videoIsMuted ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Icon, {
        icon: mutedIcon
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Icon, {
        icon: unmutedIcon
      }),
      label: videoIsMuted ? _videoText.default[copy].unmute : _videoText.default[copy].mute,
      disableFocus: disableFocus,
      onClick: toggleMute,
      onFocus: resetInactivityTimer
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledVolumeSlider, {
      type: "range",
      min: "0",
      max: "1",
      step: "any",
      value: videoCurrentVolume,
      videoCurrentVolume: videoCurrentVolume,
      ref: refVolumeSlider,
      onChange: handleVolumeChange,
      onFocus: resetInactivityTimer,
      tabIndex: "-1",
      "aria-label": _videoText.default[copy].volumeSliderLabel,
      ...sharedProps
    })]
  });
};
VolumeSlider.propTypes = {
  ...selectedSystemPropTypes,
  videoCurrentVolume: _propTypes.default.number.isRequired,
  setVolume: _propTypes.default.func.isRequired,
  videoIsMuted: _propTypes.default.bool.isRequired,
  toggleMute: _propTypes.default.func.isRequired,
  resetInactivityTimer: _propTypes.default.func.isRequired,
  copy: _propTypes.default.oneOf(['en', 'fr']).isRequired,
  compactModeThreshold: _propTypes.default.number.isRequired,
  videoPlayerWidth: _propTypes.default.number.isRequired,
  disableFocus: _propTypes.default.bool.isRequired
};
var _default = exports.default = VolumeSlider;